"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftModal = void 0;
const ac_1 = require("@app/ac");
const delete_template_shift_1 = __importDefault(require("@app/ac/delete-template-shift"));
const ui_1 = require("@app/component/ui");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const is_admin_1 = require("@app/util/hooks/is-admin");
const use_plugin_1 = require("@app/util/hooks/use-plugin");
const use_modal_1 = require("@app/util/modal/use-modal");
const react_1 = __importStar(require("react"));
const confirm_1 = __importDefault(require("../confirm"));
const transfer_workspace_select_modal_1 = require("./components/transfer-workspace-select-modal");
const detailed_statistics_1 = require("./sections/detailed-statistics");
const dev_view_section_1 = require("./sections/dev-view-section");
const shift_footer_1 = require("./sections/shift-footer");
const shift_header_1 = require("./sections/shift-header");
const shift_history_1 = require("./sections/shift-history");
const shift_overview_sections_1 = require("./sections/shift-overview-sections");
const shift_sidebar_1 = require("./sections/shift-sidebar");
const shift_warnings_1 = require("./sections/shift-warnings");
const shift_context_1 = require("./shift-context");
const ShiftModal = ({ initialData, }) => {
    const isShiftDraft = (0, util_1.isUndefined)(initialData.shiftId);
    const templates = (0, store_1.useRootSelector)((state) => state.templates);
    const dispatch = (0, store_1.useRootDispatch)();
    const { addModal, closeModal } = (0, use_modal_1.useModal)();
    const { isPluginEnabled } = (0, use_plugin_1.usePlugin)();
    const isAdmin = (0, is_admin_1.useIsAdmin)();
    (0, react_1.useEffect)(() => {
        const handleKeypress = (evt) => {
            // only trigger if not focused in input/textarea/contenteditable and no text is selected
            const active = document.activeElement;
            const isInput = active &&
                (['INPUT', 'TEXTAREA', 'SELECT'].includes(active.tagName) ||
                    active.isContentEditable);
            const hasSelection = window.getSelection()?.toString().length ||
                (active instanceof HTMLInputElement || active instanceof HTMLTextAreaElement
                    ? active.selectionStart !== active.selectionEnd
                    : false);
            if (isInput || hasSelection)
                return;
            // Ctrl+C
            if ((evt.ctrlKey || evt.metaKey) && evt.keyCode === 67) {
                if (util_1.multiSelectUtil
                    .getMultiSelectAllowedActionTypes(isPluginEnabled)
                    .some((a) => a.type === 'copy')) {
                    closeModal();
                    util_1.notification.success({ code: 'eventCopied', message: undefined });
                    void dispatch((0, ac_1.setCalendarMultiSelect)({
                        action: 'copy',
                        isSelectingTargets: true,
                        targets: [],
                    }));
                }
                else if (util_1.multiSelectUtil
                    .getMultiSelectAllowedActionTypes(isPluginEnabled)
                    .some((a) => a.type === 'applyShiftTemplate')) {
                    closeModal();
                    util_1.notification.success({ code: 'eventCopied', message: undefined });
                    void dispatch((0, ac_1.setCalendarMultiSelect)({
                        action: 'applyShiftTemplate',
                        isSelectingTargets: true,
                        targets: [],
                    }));
                }
            }
        };
        if (initialData.subType === 'dsProTransfer') {
            return;
        }
        document.addEventListener('keydown', handleKeypress, false);
        return () => {
            document.removeEventListener('keydown', handleKeypress, false);
        };
    }, [initialData.subType]);
    const [transferWorkspaceId, setTransferWorkspaceId] = react_1.default.useState();
    if (initialData.subType === 'dsProTransfer' && !transferWorkspaceId) {
        return (react_1.default.createElement(transfer_workspace_select_modal_1.TransferWorkspaceSelectModal, { onSuccess: (workspaceId) => setTransferWorkspaceId(workspaceId), initialWorkspaceId: initialData.transferDetails?.masterShiftWorkspaceId }));
    }
    return (react_1.default.createElement(shift_context_1.ShiftProvider, { initialData: initialData }, ({ selectedTab, initialLoad, dummyShift, disabledEditation, transferStatus, transferRole, }) => (react_1.default.createElement(ui_1.Modal, { sidebarContent: initialLoad ? null : react_1.default.createElement(shift_sidebar_1.ShiftSidebar, null), size: 'size-l', dataTour: 'schedule-shift-modal', headerContent: react_1.default.createElement(shift_header_1.ShiftHeader, null), footerContent: react_1.default.createElement(shift_footer_1.ShiftFooter, null), afterClose: () => {
            // this will get called only when the modal is closed normally - not by pressing Ctrl+C
            util_1.multiSelectUtil.multiSelectClear();
        }, extraHeaderButtons: [
            !isShiftDraft &&
                (initialData.type === 'live' ||
                    initialData.type === 'cycle' ||
                    initialData.type === 'template') ? (react_1.default.createElement(ui_1.Icon, { testid: 'delete-shift-button', size: 'small', ico: 'delete', color: 'red', disabled: (0, util_1.isDefined)(disabledEditation) || transferStatus === 'pending', onClick: async () => {
                    addModal(confirm_1.default, {
                        onConfirm: async () => {
                            if (initialData?.type === 'live') {
                                await dispatch((0, ac_1.deleteLiveShift)(initialData.shiftId, undefined, undefined, transferRole === 'master'));
                            }
                            if (initialData?.type === 'template') {
                                const ts = templates
                                    ?.find((t) => t.id === initialData.templateId)
                                    ?.requirements // @ts-expect-error
                                    ?.find((s) => s.hash === initialData.shiftId);
                                await dispatch((0, delete_template_shift_1.default)(initialData.templateId, ts));
                            }
                            if (initialData?.type === 'cycle') {
                                await dispatch((0, ac_1.deleteCycleDetail)({
                                    data: {
                                        id: initialData?.shiftId,
                                    },
                                }));
                            }
                            closeModal();
                        },
                        title: (0, util_1.t)('MULTI_ACTION_DEL_CONFIRM_TITLE'),
                        type: ui_1.Alert.TYPES.ERROR,
                        confirmLabel: (0, util_1.t)('DELETE'),
                        cancelLabel: (0, util_1.t)('CANCEL'),
                        subtitle: (0, util_1.t)('MULTI_ACTION_DEL_CONFIRM_DELETE_SUBTITLE_X', {
                            x: 1,
                        }),
                        buttonColor: 'red',
                    });
                } })) : undefined,
        ].filter(util_1.isDefined) }, initialLoad ? (react_1.default.createElement(ui_1.Loader, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: {
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box',
                justifyContent: 'space-between',
            } },
            react_1.default.createElement("div", { style: {
                    flexGrow: 1,
                    overflowY: 'scroll',
                    paddingBottom: '1rem',
                    paddingLeft: '1rem',
                    paddingRight: '1rem',
                    paddingTop: '1rem',
                } },
                selectedTab === 'overview' && react_1.default.createElement(shift_overview_sections_1.ShiftOverviewSections, null),
                selectedTab === 'statistics' && (react_1.default.createElement(detailed_statistics_1.DetailedStatistics, { shift: dummyShift })),
                selectedTab === 'history' && react_1.default.createElement(shift_history_1.ShiftHistory, null),
                selectedTab === 'dev-view' && isAdmin && react_1.default.createElement(dev_view_section_1.DevViewSection, null)),
            selectedTab === 'overview' ? (react_1.default.createElement("div", { style: {
                    paddingLeft: '1rem',
                    paddingRight: '1rem',
                    display: 'flex',
                    flexDirection: 'column',
                } },
                react_1.default.createElement(shift_warnings_1.ShiftWarnings, null),
                transferRole === 'slave' && transferStatus === 'pending' ? (react_1.default.createElement("div", { style: {
                        paddingBottom: '0.5rem',
                    } },
                    react_1.default.createElement(ui_1.Alert, { size: 'FULL_WIDTH', type: 'WARNING', text: (0, util_1.t)('TRANSFER_WAITING_FOR_REPLY_MESSAGE') }))) : (false))) : (false))))))));
};
exports.ShiftModal = ShiftModal;
